<div *ngIf="accessdenied" class="row">
    <div class="col-md-12 no-padding">
        <app-access-denied></app-access-denied>
    </div>
</div>
<div *ngIf="!accessdenied" class="row" style=" margin-right: 20px; margin-left: 20px; margin-bottom: 20px;">
    <div class="col-md-12 no-padding">

        <div class="row">
            <div class="col-xl-12 cover-photo-box default-bg" style="background-size: cover;"
                 [ngStyle]="{'background-image': 'url(' + article.coverImage + ')', 'height':'454px'}">

            </div>

        </div>
        <div class="row block-style" style="border-top-left-radius: 0; border-top-right-radius: 0; padding-top: 5px;">
            <ul class="blog-social" style="display:flex; opacity:.5">
                <li class="digits" style="padding: 5px; padding-left: 0px;">{{article.publishedDate | date}}</li>
                <li class="digits" style="padding:5px">|</li>
                <li class="digits" style="padding:5px">{{article.authorName}}</li>
                <li class="digits" style="padding:5px">|</li>
                <li class="digits" style="padding:5px">{{article.source}}</li>
                <li class="digits" style="padding:5px">|</li>
                <li class="digits" style="padding:5px"> {{article.viewCount}}<span> Hits</span></li>

            </ul>
            <h2 style="padding-top: 30px; padding-bottom: 30px; padding-left: 50px; padding-right: 50px; font-size: 35px;" class="text-center profile-name">{{article.title}}</h2>

            <div id="q_description" class="single-blog-content-top" [innerHTML]="article.article"></div>


        </div>

        <div class="row block-style" style="border-top-left-radius: 5; border-top-right-radius: 5; padding-top: 5px;margin-top:20px">
            <h2 style="padding-top: 20px; padding-bottom: 20px; padding-left: 20px; padding-right: 20px; font-size: 25px; text-align: left !important;" class="text-center profile-name">Leave your comment</h2>
            <app-post-list [showCommentsOnly]="'true'" [isNewsFeed]="'false'" [relatedTo]="'articles'" [relatedId]="id"></app-post-list>

        </div>
            



        </div>
    </div>




















<!--<div class="col-sm-12">
    <div class="blog-single">
        <div class="blog-box blog-details">
            <img class="img-fluid w-100" [src]="article.coverImage" alt="blog-main">
            <div class="blog-details-main">
                <ul class="blog-social">
                    <li class="digits">{{article.publishedDate | date}}</li>
                    <li class="digits">{{article.authorName}}</li>
                    <li class="digits">{{article.source}}</li>
                    <li class="digits">{{article.viewCount}}<span> Hits</span></li>

                </ul>
                <h4>
                    {{article.title}}
                </h4>
                <div class="single-blog-content-top" [innerHTML]="article.article"></div>
            </div>
        </div>
    </div>
</div>-->
